import React from "react";
import brand from "../brand";

const ContactUs = () => {
  return (
    <main className="page-shell legal-page">
      <section className="page-hero compact-hero">
        <span className="eyebrow">Support</span>
        <h1>Contact {brand.name}</h1>
        <p>
          Send result corrections, advertising inquiries, or platform feedback to
          our support desk.
        </p>
      </section>
      <section className="legal-copy">
        <p>
          Email us at{" "}
          <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>. Please
          include the draw date, draw time, and a clear description so we can
          review your message quickly.
        </p>
      </section>
    </main>
  );
};

export default ContactUs;
